import { initializeObservability } from '@psyomics/ui-common';

import { getConfig } from './config';
import { renderRoot } from './render-root';
import '@psyomics/ui-components/styles';

const config = getConfig();

initializeObservability({
  dsn: config.sentryDsn,
  environment: config.environment,
  hosts: [config.clinicianApiUrl],
});

renderRoot();
